import React, { useEffect, useState, useCallback, useContext } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import { BaseUrl } from "../../../contexts/baseUrl/baseUrl";

const TutorialListing = ({
  fetchTutorialData,
  questionListing,
  match,
  history,
}) => {
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      fetchTutorialData(1);
      setIsLoading(false);
    })();
  }, []);
  const headers = ["Question", "Answer", "Created By"];

  useEffect(() => {
    if (
      questionListing &&
      questionListing?.data &&
      questionListing?.data.length > 0
    ) {
      const tableData = ["question", "answer", "created_by"];
      const data = questionListing?.data.map((element) =>
        Object.assign(...tableData.map((key) => ({ [key]: element[key] })))
      );
      if (data) {
        data && setListData(data);
      }
      setPageCount(Math.ceil(questionListing.total / questionListing.per_page));
    }
  }, [questionListing]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await fetchTutorialData(val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <>
        <Button
          onClick={() => {
            history.push(`${baseUrl}/tutorial-questions`);
          }}
          className="filter-hamburger btn btn-transparent"
        >
          {localization.addQuestion}
        </Button>
      </>
    );
  };
  return (
    <Layout
      title={localization.tutorialListing}
      isLoading={isLoading}
      Buttons={headerBtns}
    >
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={questionListing && questionListing.data}
        srNo={questionListing?.from}
      />
    </Layout>
  );
};

export default TutorialListing;
